import { WatchQueryFetchPolicy } from '@apollo/client';

import { ActivitiesFontSize, LanguageCodes } from 'global/constants';
import type {
  GetDraftAssessmentActivitiesQuery,
  GetDraftAssessmentActivitiesQueryVariables,
} from '../assessment/assessment-builder.graphql.generated';
import { GET_DRAFT_ASSESSMENT_ACTIVITIES } from '../assessment/assessment-builder.graphql';
import { useActivityBuilderTheme } from '../theme/activity-builder-theme';
import { useGetInteractiveLessonParams } from '../activity-builder.hooks';
import { useLoggingQuery } from 'lib/apollo/apollo-hooks';

type Props = {
  contentId?: number;
  fetchPolicy?: WatchQueryFetchPolicy;
  skip?: boolean;
  language?: LanguageCodes;
};

export const useGetDraftAssessmentActivities = ({
  contentId,
  fetchPolicy = 'cache-first',
  skip,
  language,
}: Props) => {
  const { userClassId } = useGetInteractiveLessonParams();
  const { updateFontSize } = useActivityBuilderTheme();

  const {
    data: draftData,
    loading,
    error,
  } = useLoggingQuery<
    GetDraftAssessmentActivitiesQuery,
    GetDraftAssessmentActivitiesQueryVariables
  >(
    GET_DRAFT_ASSESSMENT_ACTIVITIES,
    {
      skip: !!(!contentId || skip),
      fetchPolicy,
      variables: {
        input: {
          contentId: contentId || 0,
          classId: userClassId,
          language,
        },
      },
      onCompleted: res => {
        if (res.getDraftAssessmentActivities.styles) {
          updateFontSize(
            res.getDraftAssessmentActivities.styles
              .fontSize as ActivitiesFontSize
          );
        }
      },
    },
    true
  );

  return {
    data: draftData?.getDraftAssessmentActivities,
    loading,
    error,
  };
};
